import {Checker} from "./checker";

export class PVariableKit {
  /**
   * Replace variable
   * @param text text
   * @param variable variable
   */
  public static replace(text: string, variable?: Map<string, any>): string | undefined {
    if (!Checker.truthy(text))
      return text;
    if (!Checker.truthy(variable))
      return text;
    if (text.indexOf('{{') < 0 && text.indexOf('}}') < 0)
      return text;
    const regx = /[\\]?\{\{(?<varx>.*?)}}/gm;
    const tmpMark = '__THIS_IS_MAGIC_MARK_FOR_HACK_REGEX_MATCH__';
    while (true) {
      const match = regx.exec(text!);
      if (match == null)
        break;

      const originDefined = match[0];
      const originVarx = originDefined.replace('{{', '')
        .replace('}}', '');
      const varName = originVarx.trim();
      const varValue = variable.get(varName) ?? '';

      if (originDefined.startsWith('\\')) {
        const tmpDefined = originDefined.replace('\\{{', tmpMark);
        text = text.replace(originDefined, tmpDefined)
        continue
      }

      text = text.replace(originDefined, varValue);
    }
    text = text.replace(new RegExp(tmpMark, 'g'), '{{');
    return text;
  }
}
